import React from "react"
import SfLoadingSpinner from "components/Common/SfLoadingSpinner"
import Notfound from "pages/Fallback/Notfound"
import useFeatureFlags from "hooks/useFeatureFlags"
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"
import ReportingConsistency from "./index"

const ReportingConsistencyRoute = () => {
  const [isFeatureFlagActive, areFeatureFlagsLoaded] = useFeatureFlags()

  if (!areFeatureFlagsLoaded) {
    return <SfLoadingSpinner />
  }

  if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REPORTING_CONSISTENCY)) {
    return <Notfound />
  }

  return <ReportingConsistency />
}

export default ReportingConsistencyRoute
